import { ReactComponent as SvgUploadIcon } from '../../../assets/ic-smallUpload.svg';

const UploadIcon = () => <SvgUploadIcon style={{ height: 20, width: 20, minHeight: 20, minWidth: 20 }} />

export default UploadIcon;